import { createFileRoute, redirect } from '@tanstack/react-router';

/** La documentation s'ouvre sur sa première page. */
export const Route = createFileRoute('/_app/docs/')({
  beforeLoad: () => {
    throw redirect({ to: '/docs/delivery-failures', replace: true });
  },
});
